module.exports = __webpack_public_path__ + "static/media/flailing_magikarp.a9474427.gif";